export default "__VITE_ASSET__CC44mIZJ__"